import { ECustomerSource } from 'core/model/enums/customer.enum';
import { ICheckoutDetailParams } from 'core/model/interfaces/checkout.interface';
import { checkoutData } from './checkout.data';
import { mapToCheckoutDetail } from './checkout.mappers';

export const checkoutService = {
  getCheckoutDetail: async (customerId: number, customerSourceId: ECustomerSource, params?: ICheckoutDetailParams) =>
    mapToCheckoutDetail(await checkoutData.getCheckoutDetail(customerId, params), customerSourceId),
};
